// extracted by mini-css-extract-plugin
export var progressContainer = "_hg-0";